import axios from "axios";
import { getApi } from "./config";

export const verifyMobileNumber = async (mobileNumber, token) => {
  const res = await axios.post(`${getApi()}/v1/credit/ChargeCard/GetOtp`, {
    mobileNumber,
    token,
  });
  return res.data;
};

export const verifyOtp = async (otpCode, sessionId, mobileNumber) => {
  const res = await axios.post(`${getApi()}/v1/credit/ChargeCard/EnterOtp`, {
    otpCode,
    mobileNumber,
    sessionId,
  });
  return res.data;
};

export const sendPersonalInfo = async (formValues, mobileNumber, otpId) => {
  const res = await axios.post(`${getApi()}/v1/credit/ChargeCard/Charge`, {
    ...formValues,
    mobileNumber,
    sessionId: otpId,
  });
  return res.data;
};
